import React from "react";
import "./principals_desk.css";

const PrincipalsDesk = () => {
  return (
    <div>
      <h1 className="title">From the Principal's Desk</h1>
      <hr />
        
        {/*Top Section */}
        <div className="prin-top-section">
          <div className="prin-photo">
            <img
              src="/assets/images/about/Capt-Prerit-Misra.webp"
              alt="Profile"
              className="prin-profile-img"
            />
          </div>
          <div className="prin-info">
            <h2 id="prin-name">Capt. Prerit Misra</h2>
            <h4 className="innerpage-subheading">
              Principal, Maharashtra Academy of Naval Education and Training
              (MANET) Pune.
            </h4>
            <p className="prin-message">
              "Shaping Future Seafarers With World-Class Training And Education
              ."
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="prin-bottom-section">
          <p>
            The echoes of our maritime history resonate through time, from the
            bustling port of Lothal in the ancient Indus Valley Civilization to
            the maritime trade routes connecting our land with distant shores
            like Rome and the Far East.
          </p>
          <p>
            I am delighted to introduce you to Four Courses that allow you to
            embrace this legacy and shape the future of our maritime industry:
            B.Sc. Nautical Science and B. Tech Marine Engineering.
          </p>
          <p>
            Our B.Sc. Nautical Science program, of 3 years, is a voyage into the
            heart of navigation and seamanship. Just as our ancestors skillfully
            navigated the seas to establish trade and cultural links, this
            course equips you with the knowledge and skills to navigate modern
            vessels with precision. You will study subjects ranging from
            celestial navigation to maritime law, honing your leadership
            abilities and ensuring the safety of vessels, crew, and cargo. This
            program opens doors to careers as deck officers, navigating
            officers, and maritime administrators, enabling you to play a
            pivotal role in the global maritime trade network.
          </p>
          <p>
            Our B. Tech Marine Engineering course of 4 years sets you on a
            course of innovation and technical expertise. As India's maritime
            interactions with the world grew, technological prowess became
            vital. This program blends engineering fundamentals with specialized
            marine systems training. You will learn about propulsion systems,
            marine machinery, and ship construction, preparing you to become a
            qualified marine engineer. With this degree, you will steer the
            vessels of progress, ensuring their efficient operation and
            contributing to environmental sustainability through modern
            propulsion and energy management techniques.
          </p>
          <p>
            In addition, we provide Aspiring cadets a 1 Year Diploma in Nautical
            Science (DNS) leading to B. Sc Nautical Science and a 4-month
            Electro-Technical Officer (ETO) Course.
          </p>
          <p>
            All these courses carry the weight of India's maritime legacy and
            propel you toward a future where your expertise will be in high
            demand. You will be part of a select group carrying forward a
            tradition that has connected civilizations, driven trade, and shaped
            history. As you navigate through the academic waters of these
            courses, remember that you are not just acquiring knowledge – you
            are becoming a steward of our maritime heritage, entrusted with
            steering the course of progress and responsible for the safety and
            sustainability of our oceans.
          </p>
          <p>
            Employment opportunities are not just restricted to Sailing on
            Vessels - but, at later stages of one's Career, also include Shore
            based opportunities such as Surveying, Ship management, Chartering,
            Engineering opportunities ashore, Teaching etc.
          </p>
          <p>
            With the massive thrust on the Maritime sector via many initiatives
            such as "Sagarmala" the opportunities in the Shipping and Ports
            sector are India is immense.
          </p>
          <p>
            Our Mission is to make MANET the World's Premiere Maritime Training
            Institute and to produce the very best Officers with the highest
            ethical standards. So, I encourage you to embrace the spirit of
            exploration and innovation that has defined our maritime legacy.
            Choose a course that aligns with your passion - whether it's
            navigating the vast oceans or engineering the intricate systems that
            power our vessels. Embark on this journey with determination, for
            you will be the torchbearers of India's maritime future, continuing
            a legacy that has sailed through centuries and will, going forward,
            rest in your capable hands.
          </p>
          <p>With best wishes,</p>
        </div>
      </div>
  );
};

export default PrincipalsDesk;
